import React, { useContext } from 'react';
import DateTime from 'react-datetime';
import moment from 'moment';
import LocaleContext from 'constants/localization';

export default function DateEdit({ dateFormat = "DD.MM.YYYY", value, onChange, index, required }) {
  const initialValue = value === '' ? '' : moment(value).format(dateFormat);
  const LS = useContext(LocaleContext);
  const [input, setInput] = React.useState(initialValue);
  const [invalid, setInvalid] = React.useState(false);

  // e = mutating moment object or string if invalid
  // not a great time handling library...
  const handleDateChange = e => {
    if (e === '') {
      onChange({ 
        target: { value: e, getAttribute: () => index }
      });
      setInvalid(false);
      return;
    }
    if (typeof e === 'string') {
      setInput(e);
      setInvalid(true);
      return;
    }

    const date = moment(e);

    // User uses calendar to click before typing
    if (!date._i) {
      date._i = moment(date._d).format(dateFormat);
    }

    // input DD.MM.YYYY = must be 10 characters length
    const isValidDate = date._i.length === 10;

    if (isValidDate) {
      // Simulate "event" that is used in native html5 inputs for other literals
      onChange({
        target: {
          value: date.toDate().toISOString(), // ISO string for Form submission
          getAttribute: () => index // value index
        }
      });
      setInput(moment(date._d).format(dateFormat));
    } else {
      setInput(date._i);
    }

    setInvalid(!isValidDate);
  };

  return (
    <React.Fragment>
      <DateTime
        value={input}
        dateFormat={dateFormat}
        timeFormat={false}
        onChange={handleDateChange}
        inputProps={{ required }}
        utc={true}
        locale={LS.getLanguage()}
      />
      { invalid && <span className="text-danger">{LS.error.invalidDate}</span> }
    </React.Fragment>
  );
}